export function formatDateOfBirth(value) {
    const cleaned = value.replace(/\D/g, '');

    let formatted = '';
    if (cleaned.length > 0) {
        formatted = cleaned.substring(0, 2);
    }
    if (cleaned.length > 2) {
        formatted += '/' + cleaned.substring(2, 4);
    }
    if (cleaned.length > 4) {
        formatted += '/' + cleaned.substring(4, 8);
    }

    let submitFormat = '';
    if (cleaned.length === 8) {
        const month = cleaned.substring(0, 2);
        const day = cleaned.substring(2, 4);
        const year = cleaned.substring(4, 8);
        submitFormat = year + "-" + month + "-" + day;
    }
    
    return { formatted, submitFormat };
}


export function isAtLeast18YearsOld(birthDateString) {
    const birthDate = new Date(birthDateString);
    if (isNaN(birthDate.getTime())) {
        return false;
    }
    const today = new Date();
    const eighteenYearsAgo = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate()
    );
    return birthDate <= eighteenYearsAgo;
}
